// BUILD=R23-login-redirect-hardening
import { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { loginFormSchema, LoginFormData } from "./validation";

export const useLoginForm = () => {
  const { login } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const form = useForm<LoginFormData>({
    resolver: zodResolver(loginFormSchema),
    defaultValues: {
      username: "",
      password: ""
    },
  });

  const onSubmit = async (values: LoginFormData) => {
    setIsSubmitting(true);
    console.log("[login-flow] onSubmit start, username:", values.username);

    try {
      const success = await login(values.username, values.password);
      console.log("[login-flow] onSubmit done, success:", success);
      // NB: NIET hier navigeren — Login.tsx routet via useEffect zodra
      // isAuthenticated state daadwerkelijk gecommit is. Dit voorkomt de
      // race waarbij ProtectedRoute met oude state nog naar /login bouncet.
      if (!success) {
        console.log("[login-flow] login returned false (toast already shown)");
      }
    } catch (error) {
      console.error("[login-flow] onSubmit error:", error);
      toast.error("Er is een fout opgetreden bij het inloggen");
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    form,
    isSubmitting,
    onSubmit: form.handleSubmit(onSubmit)
  };
};